import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { AdminService } from "src/app/shared/services/admin/admin.service";
import { NotificationsService } from "src/app/shared/services/notifications/notifications.service";
import { createNotification } from "src/app/shared/utils/create-notification";
import { TranslateService } from "@ngx-translate/core";
import {
  invitedGroupStudentsListLoad,
  invitedGroupStudentsListLoadSuccess,
  invitedGroupStudentsListLoadFail,
} from "../../actions/admin/invited-group-students.actions";
import { GroupStudents } from "src/app/shared/interfaces/orgadmin/invited-students";
import {
  archiveGroupStudentsLoad,
  archiveGroupStudentsLoadFail,
  archiveGroupStudentsLoadSuccess,
} from "../../actions/admin/archive-group.actions";
import { singleActiveTeacherLoad } from "../../actions/admin/single-active-teacher.actions";

@Injectable()
export class InvitedGroupStudentsEffect {
  getInivitedGroupStudentsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invitedGroupStudentsListLoad),
      switchMap((param) => {
        return this.adminService
          .getInvitedStudentsInGroup(
            param.organizationId,
            param.teacherId,
            param.groupId,
          )
          .pipe(
            map((res: GroupStudents) =>
              invitedGroupStudentsListLoadSuccess({ invitedStudents: res }),
            ),
            catchError(({ error }) =>
              of(invitedGroupStudentsListLoadFail(error)),
            ),
          );
      }),
    ),
  );

  archiveGroupStudents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(archiveGroupStudentsLoad),
      switchMap((param) =>
        this.adminService
          .archiveGroup(param.organizationId, param.teacherId, param.groupId)
          .pipe(
            tap(() => {
              this.notificationsService.showToastr(
                createNotification({
                  content: {
                    message: this.translate.instant(
                      "GLOBAL.SNACKBAR_MESSAGES.TEACHER_ARCHIVE_GROUP",
                      {
                        name: param.groupName,
                      },
                    ),
                  },
                }),
              );
            }),
            switchMap(() => [
              singleActiveTeacherLoad({
                organizationId: param.organizationId,
                teacherId: param.teacherId,
              }),
              archiveGroupStudentsLoadSuccess({ groupId: param.groupId }),
            ]),
            catchError(({ error }) => of(archiveGroupStudentsLoadFail(error))),
          ),
      ),
    ),
  );

  constructor(
    private adminService: AdminService,
    private actions$: Actions,
    private notificationsService: NotificationsService,
    private translate: TranslateService,
  ) {}
}
